<script setup lang="ts">
  import dayjs from 'dayjs';
  import { computed } from 'vue';

  interface Props {
    time: dayjs.Dayjs;
    timezone?: string;
  }

  interface TimeItem {
    suffix?: string;
    time: dayjs.Dayjs;
  }

  const props = defineProps<Props>();

  const times = computed<TimeItem[]>(() => {
    const vals: TimeItem[] = [
      {
        suffix: props.timezone ? 'Your company' : 'Your computer',
        time: props.time,
      },
    ];

    const localTz = dayjs.tz.guess();
    if (props.timezone && props.timezone !== localTz) {
      vals.push({
        suffix: 'Your computer',
        time: props.time.tz(localTz),
      });
    }

    if (props.timezone !== 'UTC') {
      vals.push({
        time: props.time.clone().utc().tz('UTC'),
      });
    }

    return vals;
  });
</script>

<template>
  <div
    class="flex flex-col gap-1.5 text-xs [&>:not(:nth-last-child(1))]:pb-1.5 [&>:not(:nth-last-child(1))]:border-b"
  >
    <div class="border-b text-xs">
      <strong>Time Conversion</strong>
    </div>

    <div
      v-for="(timeItem, index) in times"
      :key="index"
      class="grid grid-cols-[150px_60px_auto] gap-6"
    >
      <span class="font-semibold">
        {{ timeItem.time.format('z') }}
        <span v-if="timeItem.suffix"> • {{ timeItem.suffix }} </span>
      </span>

      <span class="text-right">{{ timeItem.time.format('h:mm A') }}</span>

      <span class="text-left">{{ timeItem.time.format('MMM D, YYYY') }}</span>
    </div>
  </div>
</template>

<style scoped></style>
